<template>
    <div>
        <h3>Pessoa(s) para transferir</h3>
        <table class="b-table table table-striped b-table-stacked-md">
            <thead>
                <tr>
                    <th>Nome completo</th>
                    <th>Idade</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pessoa in selecteds" :key="pessoa.id">
                    <td>{{ pessoa.nome_completo }}</td>
                    <td>{{ pessoa.idade }} ano(s)</td>
                </tr>
            </tbody>
        </table>
        <form @submit.prevent="submit">
            <div class="row">
                <h3 class="col-12">Endereço da Família</h3>

                <div class="col-md-12">
                    <form-endereco :item="endereco" />
                </div>
            </div>
            <div class="alert alert-warning p-2">
                <i class="mdi mdi-alert mdi-24px"></i> você está preste a criar
                uma nova familia, então antes de continuar será necessário
                escolher um novo responsável.
            </div>
            <h3>Selecione o novo Responsável</h3>
            <SetNovoResponsavel
                :familiares="pessoasSelects"
                @selected="SetResponsavel"
            />

            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-success" type="submit">
                        <i class="fas fa-share"></i> Concluir Transferência
                    </button>
                    <button
                        class="btn btn-danger mr-0"
                        @click="$emit('cancelar')"
                    >
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                </div>
            </div>
        </form>
        <load v-if="loadingSearch" mode="table" />
    </div>
</template>
<script>
import SetNovoResponsavel from "../Remanejar/SetNovoResponsavel";
export default {
    props: ["pessoas", "selecteds", "endereco", "pessoasSelects"],
    components: { SetNovoResponsavel },
    data() {
        return {
            familiaSelected: "",
            responsavel: false,
            tipos: [
                { id: "codigo", value: "Código familiar" },
                { id: "nis", value: "NIS" },
                { id: "cpf", value: "CPF" }
            ],
            tipobusca: "",
            itembusca: "",
            loadingSearch: false
        };
    },
    methods: {
        SetResponsavel(pessoa) {
            this.$emit("responsavel", pessoa);
            this.responsavel = true;
        },
        submit() {
            if (this.responsavel) {
                this.$emit("store");
            } else {
                swal.fire({
                    title:
                        "É necessário selecionar o responsável para essa nova familia.",
                    icon: "warning",
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        }
    }
};
</script>
